export default "__VITE_ASSET__5LYZCd8T__"